import { redirect } from 'react-router-dom';
import type { LoaderFunctionArgs } from 'react-router-dom';

export function gameCodeLoader({ request, params }: LoaderFunctionArgs) {
  const { gameCode } = params;

  // the game code is valid even if it is not in uppercase, but it cannot receive game state broadcasts.
  if (gameCode && gameCode !== gameCode.toUpperCase()) {
    const url = new URL(request.url);

    const fixedPathname = url.pathname.replace(
      gameCode,
      gameCode.toUpperCase()
    );
    return redirect(fixedPathname + url.search + url.hash);
  }

  return null;
}
